import React from 'react'

import Search from '../../containers/GamesSearchFormBox'
import Icons from './components/Icons'
import { Section } from './styles/Section'
import { Wrapper } from './styles/Wrapper'

export default function GamesNavBar() {
  return (
    <Wrapper>
      <Search />
      <Section>
        <Icons />
      </Section>
    </Wrapper>
  )
}
